export default __webpack_public_path__ + "static/media/scripture_body.01d70ec2.png";